"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CustomerReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="240957" id="customer-reviews" className="py-24 bg-background text-foreground relative overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            What Our Customers Say
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-lg opacity-90"></div>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="p-8 md:p-12 text-center bg-card rounded-2xl border border-border shadow-md flex flex-col items-center justify-center">
            <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed">
              Genuine customer reviews will be published here with the reviewer's name or initials and the original review source.
            </p>
            <Link to="#get-your-free-quote-today" className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors shadow">
              Request a Quote
            </Link>
          </div>
        </div>
      </div>
    </section>;
}